module.exports = __webpack_public_path__ + "img/text1.0527719f.png";